<template>
  <div>
    <nav v-if="isAuthenticated" class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="container-fluid d-flex align-items-center">

        <router-link to="/positions" class="navbar-brand d-flex align-items-center">
          <img src="@/assets/favicon-32x32.png" alt="Prescient Logo" class="brand-logo">
          <template v-if="!isMobile">PRESCIENT</template>
        </router-link>

        <!-- 2️⃣ Balance pour MOBILE -->
        <template v-if="isMobile">
          <div class="d-flex align-items-center ms-3 balance-mobile">
            <span class="p-0 me-2 d-flex align-items-center">
              <span class="text-white">USDT:</span>&nbsp;
              <span class="text-success">{{ formatChfStyle(totalAllUsdt) }}</span>
              <span class="text-white mx-2">|</span>
              <span class="text-white">CHF:</span>&nbsp;
              <span
                  class="text-success"
                  :title="fxUsdtChfLabel"
              >
                {{ formatChfStyle(totalChf) }}
              </span>
            </span>
          </div>
        </template>

        <!-- 3️⃣ Hamburger bouton toujours à droite -->
        <button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- 4️⃣ Menu normal (desktop ou hamburger) -->
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav w-100 align-items-center" @click="closeNavbar">
            <li class="nav-item me-2">
              <router-link to="/dashboard" class="nav-link" :class="{ active: $route.path === '/dashboard' }">
                Dashboard
              </router-link>
            </li>
            <li class="nav-item me-2">
              <router-link to="/martingale" class="nav-link" :class="{ active: $route.path === '/martingale' }">Leaders</router-link>
            </li>
            <li class="nav-item me-2">
              <router-link to="/factory" class="nav-link" :class="{ active: $route.path === '/factory' }">Factory</router-link>
            </li>
            <li class="nav-item me-2">
              <router-link to="/parameters" class="nav-link" :class="{ active: $route.path === '/parameters' }">Parameters</router-link>
            </li>
            <li class="nav-item me-2">
              <router-link to="/analyzer" class="nav-link" :class="{ active: $route.path === '/analyzer' }">Analyzer</router-link>
            </li>

            <template v-if="!isMobile">
              <li class="nav-item ms-auto d-flex align-items-center">
                <span class="p-0 me-2 d-flex align-items-center">
                  <span class="text-white">USDT:</span>&nbsp;
                  <span class="text-success">{{ formatChfStyle(totalAllUsdt) }}</span>
                  <span class="text-white mx-2">|</span>
                  <span class="text-white">CHF:</span>&nbsp;
                  <span
                      class="text-success"
                      :title="fxUsdtChfLabel"
                  >
                    {{ formatChfStyle(totalChf) }}
                  </span>
                </span>
              </li>
              <li class="nav-item">
                <a class="nav-link logout-button" href="#" @click="logout">Logout</a>
              </li>
            </template>

            <template v-else>
              <li class="nav-item ms-auto">
                <a class="nav-link logout-button" href="#" @click="logout">Logout</a>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </nav>

    <!-- ✅ On laisse Vue Router gérer le composant courant -->
    <router-view />
  </div>
</template>


<script>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { useRoute, useRouter } from "vue-router";

const VITE_WS_URL = import.meta.env.VITE_WS_URL;
const VITE_REST_URL = import.meta.env.VITE_REST_URL;

import {
  positionsSL,
  ordersSL,
  binanceSLSummary,

  positionsSLLeaders,
  ordersSLLeaders,
  binanceSLSummaryLeaders,

  positionsSLFactory,
  ordersSLFactory,
  binanceSLSummaryFactory,

  walletBalances,
  walletHistory,
  setWebSocket,
  settings
} from '@/state';



export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isAuthenticated = ref(!!localStorage.getItem("token"));

    function formatChfStyle(x) {
      const n = Number(x);
      if (!Number.isFinite(n)) return "...";
      return new Intl.NumberFormat("de-CH", { maximumFractionDigits: 0 }).format(n);
    }


    const totalAllUsdt = computed(() => {
      let sum = 0;
      for (const r of (walletBalances.value || [])) {
        const v = Number(r.total_usdt);
        if (Number.isFinite(v)) sum += v;
        else if ((r.asset === "USDT" || r.asset === "USDC") && Number.isFinite(Number(r.total))) sum += Number(r.total);
      }
      return sum;
    });

    const fxUsdtChf = computed(() => Number(settings.value?.fx_usdt_chf) || 0.8);
    const totalChf = computed(() => totalAllUsdt.value * fxUsdtChf.value);

    const fxUsdtChfLabel = computed(() =>
        `FX USDT → CHF: ${fxUsdtChf.value.toFixed(6)}`
    );

    function format0(x) {
      const n = Number(x);
      if (!Number.isFinite(n)) return "...";
      return Math.round(n).toString();
    }


    const isMobile = ref(window.innerWidth < 992);

    const handleResize = () => {
      isMobile.value = window.innerWidth < 992;
    };

    let socket = null;

    const handleLoginSuccess = (token) => {
      localStorage.setItem("token", token);
      localStorage.setItem("isAuthenticated", "true");
      isAuthenticated.value = true;
      router.push("/cryptos");
    };

    const logout = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("isAuthenticated");
      isAuthenticated.value = false;
      router.push("/login");
    };

    const closeNavbar = () => {
      const navbar = document.querySelector(".navbar-collapse");
      if (navbar && navbar.classList.contains("show")) {
        navbar.classList.remove("show");
      }
    };

    const fetchInitData = async () => {
      try {
        const response = await fetch(`${VITE_REST_URL}/init-data`);
        const data = await response.json();
        traderStats.value = data.traderStats || {};
        cryptoSummary.value = data.cryptoSummary || {};
        console.log("✅ Init data loaded");
      } catch (error) {
        console.error("❌ Failed to fetch init data:", error.stack || error.message);
      }
    };

    const connectToWebSocket = () => {
      console.log(`🔌 Connecting WebSocket to ${VITE_WS_URL}`);
      socket = new WebSocket(VITE_WS_URL);
      setWebSocket(socket);

      socket.onmessage = (event) => {
        try {
          const receivedData = JSON.parse(event.data);
          switch (receivedData.type) {
            case "positions_sl":
              positionsSL.value = receivedData.data;
              break;
            case "orders_sl":
              ordersSL.value = receivedData.data;
              break;
            case "binance_sl_summary":
              binanceSLSummary.value = receivedData.data;
              break;
            case "wallet_balances":
              walletBalances.value = [...receivedData.data];
              break;
            case "wallet_history":
              walletHistory.value = receivedData.data || [];
              break;
            case "settings":
              settings.value = { ...settings.value, ...receivedData.data };
              break;
            case "positions_sl_leaders":
              positionsSLLeaders.value = receivedData.data;
              break;
            case "orders_sl_leaders":
              ordersSLLeaders.value = receivedData.data;
              break;
            case "binance_sl_summary_leaders":
              binanceSLSummaryLeaders.value = receivedData.data;
              break;

            case "positions_sl_factory":
              positionsSLFactory.value = receivedData.data;
              break;
            case "orders_sl_factory":
              ordersSLFactory.value = receivedData.data;
              break;
            case "binance_sl_summary_factory":
              binanceSLSummaryFactory.value = receivedData.data;
              break;
          }
        } catch (error) {
          console.error("❌ WebSocket error:", error.stack || error.message);
        }
      };

      socket.onclose = () => {
        console.warn("❌ WebSocket disconnected. Reconnecting in 5 seconds...");
        setTimeout(connectToWebSocket, 5000);
      };
    };

    onMounted(() => {
      //fetchInitData();
      connectToWebSocket();
      window.addEventListener("resize", handleResize);
    });

    onBeforeUnmount(() => {
      if (socket) {
        socket.close();
      }
      window.removeEventListener("resize", handleResize);
    });

    return {
      isAuthenticated,
      handleLoginSuccess,
      logout,
      closeNavbar,
      totalAllUsdt,
      totalChf,
      fxUsdtChfLabel,
      format0,
      formatChfStyle,
      isMobile,
      route
    };
  }
};

// ✅ Exporte les données centrales pour d'autres composants
export {
  positionsSL,
  ordersSL,
  binanceSLSummary
};
</script>




<style scoped>
.brand-logo {
  height: 20px; /* Ajuste la hauteur selon tes besoins */
  width: auto; /* Garde les proportions */
  margin-right: 8px; /* Espacement entre l'image et le texte */
  vertical-align: middle; /* Alignement avec le texte */
}

.navbar {
  background-color: #1e2126;
}

.navbar-brand {
  color: #26a69a;
}

.nav-link {
  color: #fff;
  font-size: 16px;
}

.nav-link:hover,
.nav-link.active {
  color: #26a69a; /* Couleur spéciale pour l'élément actif */
  font-weight: bold;
}

/* ✅ Active la mise en évidence du menu en cours */
.navbar-nav .nav-link.active {
  font-weight: bold;
  color: #26a69a !important; /* ✅ Met la couleur en vert clair */
}

/* ✅ Positionne le bouton Logout à droite */
.ms-auto {
  margin-left: auto;
}


/* ✅ S'assure que le menu est bien flexbox pour positionner Logout à droite */
.navbar-nav {
  display: flex;
  width: 100%;
}

/* ✅ Harmonise la couleur du bouton Logout */
.logout-button {
  font-weight: bold;
  color: white !important;
  transition: color 0.3s;
}

.logout-button:hover {
  color: #26a69a !important; /* ✅ Vert clair au survol */
}

@media (max-width: 991px) {
  .balance-mobile {
    font-size: 0.75rem !important;
  }
}

</style>
